(function($) {
    "use strict";

    /*************************
     typed js start
     *************************/
    $(function () {
        $(".typed").typed({
            strings: ["Unice"],
            stringsElement: null,
            typeSpeed: 120,
            backSpeed: 30,
            showCursor: false,
            loop: true,
            cursorChar: "|",
            attr: null,
            contentType: 'html',
            callback: function () {
            },
            preStringTyped: function () {
            },
            onStringTyped: function () {
            },
            resetCallback: function () {
            }
        });
    });
    /*************************
     typed js end
     *************************/
    /*************************
     typed js start
     *************************/
    $(function () {
        $(".typed-resume").typed({
            strings: ["css, bootstrap, java script, jquery"],
            stringsElement: null,
            typeSpeed: 120,
            backSpeed: 30,
            showCursor: false,
            loop: true,
            cursorChar: "|",
            attr: null,
            contentType: 'html',
            callback: function () {
            },
            preStringTyped: function () {
            },
            onStringTyped: function () {
            },
            resetCallback: function () {
            }
        });
    });
})(jQuery);

/*************************
 typed js end
 *************************/